import Intercom from "@intercom/messenger-js-sdk";

Intercom({
  app_id: "tdkgozdw",
});
